import { useEffect, useState } from 'react';

import { ExclamationCircleFilled } from '@ant-design/icons';
import useUserStore from '@lcsc-ui/store/user';
import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';
import { Alert, Button } from 'antd';

import AuditBox from './AuditBox'; // 合规审计弹窗
// import ConfirmBelongBox from './ConfirmBelongBox'; // 账号归属弹窗

import { invoiceIframeActions } from '@/utils/iframe';

const confirmBelongClose = () => {
  sendAxios({
    method: 'post',
    url: '/async/customer/belong/temporary/confirm',
    baseURL: Domains.lcscWwwUrl,
  });
};

const TopAlert = () => {
  const { userInfo } = useUserStore();
  const isLogined = userInfo?.customerLogin === 1;

  const [dialogVisible, setDialogVisible] = useState(null);
  /** dialogType类型如下：
   *
   *  AuditBox：只有合规审计弹窗
      AuditBoxAndConfirmBox：合规审计和账号归属都有
      ConfirmBelongBox：只有账号归属弹窗
   */
  const [dialogType, setDialogType] = useState(null);
  const [auditDialogInfo, setAuditDialogInfo] = useState(0);
  const [confirmBelongDialogInfo, setConfirmBelongDialogInfo] = useState(0);

  function jumpToBelongPage(cbs = []) {
    sendAxios({
      method: 'get',
      url: '/async/is/confirm/belong/company/v2',
      baseURL: Domains.lcscMemberUrl,
    }).then((res) => {
      if (res.code === 200 && res.result) {
        let href = Domains.lcscMemberUrl + '/member/lcConfirmBelong.html';
        href += '?s=' + encodeURIComponent(window.location.href);
        window.location.href = href;
      } else {
        cbs.forEach((cb) => cb());
      }
    });
  }

  function fecthConfirmBelongDialogInfo() {
    sendAxios({
      method: 'get',
      url: '/async/is/confirm/belong/company/dialog/v2',
      baseURL: Domains.lcscMemberUrl,
    })
      .then((res) => {
        if (res.code === 200 && res.result) {
          setConfirmBelongDialogInfo(true);
        } else {
          setConfirmBelongDialogInfo(false);
        }
      })
      .catch((err) => {
        console.error('www项目的fecthConfirmBelongDialogInfo' + err);
        setConfirmBelongDialogInfo(false);
      });
  }

  function fecthAuditDialogInfo() {
    sendAxios({
      method: 'get',
      url: '/member/invoice/payer/show/v2',
      baseURL: Domains.lcscMemberUrl,
    })
      .then((res) => {
        if (res.code === 200 && res.result) {
          const { hasAlert, showType } = res.result;
          if (showType === 'dialog' || showType === 'icon') {
            if (!hasAlert) {
              // hasAlert 今天是否弹过窗
              setAuditDialogInfo('show'); // 直接弹出
            } else {
              setAuditDialogInfo('folded'); // 折叠收齐在最顶部
            }
          } else {
            setAuditDialogInfo('hide'); // 没满足条件
          }
        } else {
          setAuditDialogInfo('hide');
        }
      })
      .catch((err) => {
        console.error('www项目fecthAuditDialogInfo' + err);
        setAuditDialogInfo('hide');
      });
  }

  function handleCompleteMemberInfo() {
    if (dialogType === 'ConfirmBelongBox') {
      // 账号归属弹窗
      invoiceIframeActions.setSubject(
        () => {
          // 完成回调
          setDialogType(null);
        },
        () => {
          // 关闭回调
          sendAxios({
            method: 'post',
            url: '/async/customer/belong/temporary/confirm',
            baseURL: Domains.lcscWwwUrl,
          });
        }
      );
      return;
    }
    setDialogVisible(true);
  }

  useEffect(() => {
    if (isLogined) {
      // 函证用户的优先级最高，直接跳转到页面去确认账号归属
      jumpToBelongPage([fecthConfirmBelongDialogInfo, fecthAuditDialogInfo]);
    }
  }, [isLogined]);

  useEffect(() => {
    const handler = () => {
      window.popList();
    };
    if (auditDialogInfo !== 0 && confirmBelongDialogInfo !== 0) {
      if (['show', 'folded'].includes(auditDialogInfo) && confirmBelongDialogInfo) {
        setDialogType('AuditBoxAndConfirmBox'); // 合规弹窗 + 账号归属弹窗
        if (auditDialogInfo === 'show') {
          setDialogVisible(true); // 合规优先级高，直接弹窗！
        }
      }
      if (['show', 'folded'].includes(auditDialogInfo) && !confirmBelongDialogInfo) {
        setDialogType('AuditBox'); // 合规弹窗
        if (auditDialogInfo === 'show') {
          setDialogVisible(true); // 合规优先级高，直接弹窗！
        }
      }
      if (auditDialogInfo === 'hide' && confirmBelongDialogInfo) {
        setDialogType('ConfirmBelongBox'); // 账号归属弹窗
      }
      if (['hide', 'folded'].includes(auditDialogInfo)) {
        // 合规弹窗折叠或不显示，开始弹营销的窗（合规弹窗不能跟营销弹窗重叠）。账号归属不会主动弹窗，因此不考虑它
        if (window.popList) {
          window.popList();
        } else {
          // 监听 'popListReady' 事件
          document.addEventListener('popListMethodReady', handler);
        }
      }
    }

    // // 清理事件监听
    return () => {
      document.removeEventListener('popListMethodReady', handler);
    };
  }, [auditDialogInfo, confirmBelongDialogInfo]);

  // function handleClose() {
  //   if (dialogType === 'AuditBox' || dialogType === 'AuditBoxAndConfirmBox') {
  //     // 记录关闭次数
  //     sendAxios({
  //       method: 'post',
  //       url: '/member/invoice/payer/close',
  //       baseURL: Domains.lcscWwwUrl,
  //     });
  //     // 一天内不再弹出
  //     sendAxios({
  //       method: 'post',
  //       url: `/member/invoice/payer/confirm`,
  //       baseURL: Domains.lcscWwwUrl,
  //     });
  //     if (dialogType === 'AuditBoxAndConfirmBox') {
  //       confirmBelongClose();
  //     }
  //   } else {
  //     confirmBelongClose();
  //   }
  // }

  if (!isLogined) {
    return <></>;
  }

  return (
    <section aria-label="立创商城-首页-合规弹窗">
      {dialogVisible && (dialogType === 'AuditBox' || dialogType === 'AuditBoxAndConfirmBox') && (
        <AuditBox
          show={dialogVisible}
          dialogType={dialogType}
          setDialogType={setDialogType}
          setShow={setDialogVisible}
          confirmBelongClose={confirmBelongClose}
        />
      )}
      {/* {dialogVisible && dialogType === 'ConfirmBelongBox' && (
        <ConfirmBelongBox show={dialogVisible} closeBanner={() => setDialogType(null)} setShow={setDialogVisible} />
      )} */}
      <Alert
        banner
        className="contain-layout contain-paint contain-style"
        showIcon={false}
        message={
          dialogType ? (
            <div className="mx-auto w-[1200px] _lg:w-[1552px]">
              <ExclamationCircleFilled className="ml-[10px]" style={{ color: '#faad14' }} />
              <span className="ml-[10px]">
                为保障您的账号与资金安全，请您完善
                {['AuditBox', 'AuditBoxAndConfirmBox'].includes(dialogType)
                  ? '【订单付款人和订单主体】'
                  : '【账号归属】'}
                信息
              </span>
              <Button className="ml-[20px]" onClick={handleCompleteMemberInfo}>
                立即完善
              </Button>
            </div>
          ) : (
            ''
          )
        }
        type="warning"
        // closable={false}
        style={{
          opacity: dialogType ? '1' : '0',
          height: dialogType ? 'auto' : '0',
          padding: dialogType ? '8px 12px' : '0',
          border: dialogType ? '1px solid #ffe58f' : '0',
          transition: 'all 0.3s ease-in-out',
        }}
        // afterClose={handleClose}
      />
    </section>
  );
};

export default TopAlert;
